// store/authStore.js
import { create } from "zustand";
import { getAboutUs, postFounderFunction, postMission, postPromise, postStory } from "../api/about";

export const useAboutUsStore = create((set, get) => ({
    loading: true,
    banner: null,
    story: null,
    promise: null,
    mission: null,
    founder: null,

    getAbout: async () => {
        try {
            set({ loading: true })
            const res = await getAboutUs()
            console.log("About Us Data:", res);
            set({ loading: false, story: res?.story, mission: res?.mission, founder: res?.founder, promise: res?.promise })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        }
    },
    postAboutusStory: async (form) => {
        try {
            set({ loading: true })
            const res = await postStory(form)
            console.log("About Us Data:", res);
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        }
    },
    postPromise: async (form) => {
        try {
            set({ loading: true })
            const res = await postPromise(form)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        }
    },
    postMission: async (form) => {
        try {
            set({ loading: true })
            const res = await postMission(form)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        }
    },
    postFounder: async (form) => {
        try {
            set({ loading: true })
            const res = await postFounderFunction(form)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        }
    },
   

}));
